import { Typography } from "@mui/material";
import type { DateString } from "../api/types";

export type DateDisplayProps = {
  date?: DateString;
};

export const DateDisplay = ({ date }: DateDisplayProps) => (
  <Typography
    variant="body2"
    className="date-display"
    component="span"
    sx={{
      color: "text.secondary",
      whiteSpace: "nowrap",
    }}
  >
    {date || "-"}
  </Typography>
);
